import React, { useEffect, useState } from "react";
import "../assets/OnboardLicense.css";
import "../assets/OnboardedSolutionDetails.css";
import "../assets/CertifiedSolutionDetails.css";
import { fetchData, postData} from "../api/restapi";
import Popup from "../popups/popup";
import ConfirmationDialog from "../popups/ConfirmationDialog";

function CertifiedSolutionDetailsTab() {
  const [solutions, setSolutions] = useState([]);
  const [detailsPopup, setDetailsPopup] = useState(null);
  const [groups, setGroups] = useState([]);
  const [criteriaPopup, setCriteriaPopup] = useState(null);
  const [selectorCriteria, setSelectorCriteria] = useState(null);
  const [formData, setFormData] = useState({});
  const [uniqueIdType, setUniqueIdType] = useState("imei");
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const solutionColumns = [
    { key: "solutionId", label: "Solution Id", isClickable: true },
    { key: "description", label: "Solution Description" },
    { key: "mbnDescription", label: "Delta MBN Description" },
    { key: "state", label: "State" },
    { key: "action", label: "Action", isAction: true }
  ];

  const openDetailsPopup = (solutionId, licenses = [], mbns = []) => {
    setDetailsPopup({ solutionId, licenses, mbns });
  };

  const closeDetailsPopup = () => {
    setDetailsPopup(null);
  };

  useEffect(() => {
    const params = { state: "CERTIFIED" };
    fetchData(`/qfm/v1/solutions/portal/solutions?state=${params.state}`).then((data) => {
      setSolutions(data.solutions || []);
    });

    fetchData("/qfm/v1/solutions/portal/groups").then((data) => {
      setGroups(
        data.groups.map((group) => ({
          value: group.name,
          label: `${group.name}: ${group.selectorIds}`
        })) || []
      );
    });
  }, []);

  const openCriteriaPopup = (solutionId) => {
    setCriteriaPopup({ solutionId });
    setSelectorCriteria(null);
    setFormData({});
  };

  const closeCriteriaPopup = () => {
    setCriteriaPopup(null);
    setSelectorCriteria(null);
    setFormData({});
  };

  const handleFormSubmit = () => {
    setShowConfirmation(true);
  };

  const handleConfirm = () => {
    const postBody = {
      user: "Srivatsa",
      solutionId: criteriaPopup.solutionId,
      criteria: formData,
    };

    postData("/qfm/v1/solutions/criteria", postBody)
      .then((response) => {
        if (response.error) {
          setErrorMessage(response.error);
        } else {
          setSuccessMessage("Criteria added successfully!");
          setSolutions((prevSolutions) => prevSolutions.filter((sol) => sol.solutionId !== criteriaPopup.solutionId));
          closeCriteriaPopup();
        }
      })
      .catch((err) => setErrorMessage("Error submitting criteria: " + err.message));

    setShowConfirmation(false);
  };

  const handleCancel = () => {
    setShowConfirmation(false);
  };

  const closePopup = () => {
    setSuccessMessage("");
    setErrorMessage("");
  };

  return (
    <div className="osln-tab-container">
      {detailsPopup && <div className="overlay"></div>}
      {criteriaPopup && <div className="overlay"></div>}
      <div className="tab-heading">
        <h1>Solutions in Certified State</h1>
      </div>

      <table className="solutions-table">
        <thead>
          <tr>
            {solutionColumns.map((col) => (
              <th key={col.key}>{col.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {solutions.map((solution) => (
            <tr key={solution.solutionId}>
              {solutionColumns.map((col) => {
                if (col.isClickable) {
                  return (
                    <td
                      key={col.key}
                      className="clickable"
                      onClick={() => openDetailsPopup(solution.solutionId, solution.licenses, solution.mbns)}
                    >
                      {solution[col.key]}
                    </td>
                  );
                }
                if (col.isAction) {
                  return (
                    <td key={col.key}>
                      <button
                        className="add-criteria-button"
                        onClick={() => openCriteriaPopup(solution.solutionId)}
                      >
                        + Add Solution Matching Criteria
                      </button>
                    </td>
                  );
                }
                return <td key={col.key}>{solution[col.key] || col.defaultValue || ""}</td>;
              })}
            </tr>
          ))}
        </tbody>
      </table>

      {detailsPopup && (
        <div className="details-popup">
          <div className="popup-content">
            <h3>License Details for Solution ID #{detailsPopup.solutionId}</h3>
            <table className="details-table">
              <thead>
                <tr>
                  {[
                    { key: "licenseId", label: "License Id" },
                    { key: "description", label: "License Description" },
                    { key: "chipset", label: "Chipset", defaultValue: "-" },
                    { key: "oem", label: "OEM", defaultValue: "-" },
                    { key: "features", label: "Features" },
                  ].map((col) => (
                    <th key={col.key}>{col.label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {detailsPopup.licenses.map((license) => (
                  <tr key={license.licenseId}>
                    <td>{license.licenseId}</td>
                    <td>{license.description}</td>
                    <td>{license.chipset || "-"}</td>
                    <td>{license.oem || "-"}</td>
                    <td>{license.features.map((feature) => feature.description).join(", ")}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="spacing" />

            <h3>Delta MBN Details for Solution ID #{detailsPopup.solutionId}</h3>

            <table className="details-table">
              <thead>
                  <tr>
                      {[
                          { key: "mbnFileId", label: "Delta MBN File Id" },
                          { key: "description", label: "Delta Description" },
                          { key: "mbnIdHash", label: "Delta MBN ID Hash" },
                          { key: "fileName", label: "File Name" },
                          { key: "chipset", label: "Chipset", defaultValue: "-" },
                      ].map((col) => (
                          <th key={col.key}>{col.label}</th>
                      ))}
                  </tr>
              </thead>
              <tbody>
                  {detailsPopup.mbns.map((mbn) => (
                      <tr key={mbn.mbnFileId}>
                          <td>{mbn.mbnFileId}</td>
                          <td>{mbn.description}</td>
                          <td>{mbn.mbnIdHash || "-"}</td>
                          <td>{mbn.fileName || "-"}</td>
                          <td>{mbn.chipset || "-"}</td>
                      </tr>
                  ))}
              </tbody>
            </table>
            <button className="close-popup-button" onClick={closeDetailsPopup}>Close</button>
          </div>
        </div>
      )}

      {criteriaPopup && (
        <div className="criteria-popup">
          <div className="popup-content">
            <h3>Add Solution Matching Criteria for Solution ID: {criteriaPopup.solutionId}</h3>
            <div className="spacing" />

            <div className="row">
              <div className="dropdown-section">
                <div className='dropdown-heading'>Selector Criteria</div>
                <select
                  id="selector-criteria"
                  className="dropdown-popup"
                  value={selectorCriteria || ""}
                  onChange={(e) => {
                    setSelectorCriteria(e.target.value);
                    setFormData({});
                  }}
                >
                  <option value="" disabled>
                    Select Criteria
                  </option>
                  <option value="singledevice">Target a Device</option>
                  <option value="genralcriteria">Target a Group</option>
                </select>
              </div>
            </div>

            {selectorCriteria === "singledevice" && (
              <>
                <div className="row">
                  <div className="dropdown-section">
                    <div className='dropdown-heading'>Unique ID Type</div>
                    <select
                      id="singledev-type"
                      className="dropdown-popup"
                      onChange={(e) => {
                        setUniqueIdType(e.target.value);
                        setFormData({ ...formData, [e.target.value]: "" })
                      }}
                    >
                      <option value="imei">IMEI</option>
                      <option value="deviceId">Device ID</option>
                    </select>
                  </div>

                  <div className="dropdown-section">
                    <div className='dropdown-heading'>Unique ID</div>
                    <input
                      className="lsn-description"
                      type="text"
                      onChange={(e) =>
                        setFormData({ ...formData, [uniqueIdType]: e.target.value })
                      }
                    />
                  </div>
                </div>
              </>
            )}

            {selectorCriteria === "genralcriteria" && (
              <>
                <div className="row">
                  <div className="dropdown-section">
                    <div className='dropdown-heading'>Priority (lower numbers are higher priority)</div>
                    <select
                      id="priority"
                      className="dropdown-popup"
                      defaultValue=""
                      onChange={(e) =>
                        setFormData({ ...formData, priority: e.target.value })
                      }
                    >
                      <option value="" disabled>Select...</option>
                      {[...Array(10).keys()].map((value) => (
                        <option key={value} value={value}>
                          {value}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="dropdown-section">
                    <div className='dropdown-heading'>Target Group</div>
                    <select
                      id="group"
                      className="dropdown-popup"
                      defaultValue=""
                      onChange={(e) =>
                        setFormData({ ...formData, group: e.target                    .value })
                      }
                    >
                      <option value="" disabled>Select...</option>
                      {groups.map((group) => (
                        <option key={group.value} value={group.value}>
                          {group.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="row">
                  <div className="dropdown-section">
                    <div className='dropdown-heading'>MPSS</div>
                    <input
                      className="lsn-description"
                      type="text"
                      onChange={(e) =>
                        setFormData({ ...formData, mpss: e.target.value })
                      }
                    />
                  </div>

                  <div className="dropdown-section">
                    <div className='dropdown-heading'>APSS</div>
                    <input
                      className="lsn-description"
                      type="text"
                      onChange={(e) =>
                        setFormData({ ...formData, apss: e.target.value })
                      }
                    />
                  </div>
                </div>
              </>
            )}

            <button
              className="submit-button"
              onClick={handleFormSubmit}
              disabled={!selectorCriteria}
            >
              Submit
            </button>
            <button className="close-popup-button" onClick={closeCriteriaPopup}>
              Close
            </button>
          </div>
        </div>
      )}

      {showConfirmation && (
        <ConfirmationDialog
          message={`Are you sure you want to submit the following criteria?\n\nSolution ID: ${criteriaPopup.solutionId}\n${Object.entries(formData).map(([key, value]) => `${key}: ${value}`).join("\n")}`}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
        />
      )}

      {successMessage && (
        <Popup message={successMessage} onClose={closePopup} />
      )}

      {errorMessage && (
        <Popup message={errorMessage} onClose={closePopup} />
      )}
    </div>
  );
}

export default CertifiedSolutionDetailsTab;
